"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KeyEmployeePageOne;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _KeyEmployeeFormsControl = require("./KeyEmployeeFormsControl");
var _KeyEmployeeWizardCalc = require("./KeyEmployeeWizardCalc.config");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function KeyEmployeePageOne() {
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values,
    errors,
    touched,
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    /* istanbul ignore next */
    if (values.hasNavigatedPage) {
      document.getElementById(_KeyEmployeeWizardCalc.calcName).scrollIntoView();
      /* istanbul ignore else*/
      if (window) {
        window.scrollBy(0, -112);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "You already know how important your employees are to the success of your business. What you may not have thought about is how much the contributions of certain key employees are worth to your business - whether it's their creative genius, sales acumen, or leadership role. And, as you can see, key employees don't necessarily have to be members of your management team, but could very well be a partner or even yourself."), /*#__PURE__*/_react.default.createElement("p", null, "It's important to understand the value of key employees and the impact that losing one of them could have on your business. Use our calculator to help determine the financial value of your key employees, then learn how you can help protect your bottom line.\xA0", /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'keyEmployeeInfo',
    text: _KeyEmployeeWizardCalc.popoverConfig.keyEmployeeText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto remove-padding-right"
  }, /*#__PURE__*/_react.default.createElement(_KeyEmployeeFormsControl.IndustrySector, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'industrySector',
    text: _KeyEmployeeWizardCalc.popoverConfig.industrySectorText
  }))), /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  })));
}